<!-- Login Form -->
<div class="d-flex flex-column align-items-center justify-content-center" *ngIf="!signedIn && !passwordExpired">
    <form class="form w-50" [formGroup]="loginForm" (submit)="signIn($event)">
        <div class="row m-3">
            <label for="name">Email*</label>
            <input class="col form-field" name="email" formControlName="email" />
        </div>
        <div class="row m-3">
            <label for="password">Password*</label>
            <input class="col form-field" type="password" name="password" formControlName="password" autocomplete="on" />
        </div>
        <div class="row m-3" *ngIf="authFailed">
            <label style="color: red">{{ errorMessage }}</label>
        </div>

        <!--Display angular validation errors from the loginForm-->
        <div class="row m-3" *ngIf="loginForm.controls['email'].invalid && loginForm.controls['email'].touched">
            <label style="color: red">Email is required</label>
        </div>
        <div class="row m-3" *ngIf="loginForm.controls['password'].invalid && loginForm.controls['password'].touched">
            <label style="color: red">Password is required</label>
        </div>

        <div class="row m-3">
            <button class="col btn btn-primary" [disabled]="!loginForm.valid" type="submit">Sign In</button>
        </div>
        <div class="row m-3">
            <a routerLink="/identity/forgot-password">Forgot your password?</a>
        </div>
    </form>    
</div>

<!-- Change Expired Password Form -->
<div class="d-flex flex-column align-items-center justify-content-center" *ngIf="!signedIn && passwordExpired">
    <form class="form w-50" [formGroup]="changePasswordForm" (submit)="submitNewPassword()">
        <div class="row m-3">
            <div class="alert alert-warning">
                Your password has expired. Please set a new password to continue.
            </div>
        </div>
        <div class="row m-3">
            <label for="newPassword">New Password*</label>
            <input class="col form-field" type="password" name="newPassword" formControlName="newPassword" autocomplete="new-password" />
        </div>
        <div class="row m-3">
            <label for="confirmPassword">Confirm Password*</label>
            <input class="col form-field" type="password" name="confirmPassword" formControlName="confirmPassword" autocomplete="new-password" />
        </div>

        <div class="row m-3" *ngIf="changePasswordForm.hasError('passwordsMismatch') && changePasswordForm.get('confirmPassword')?.touched">
            <label style="color: red">Passwords do not match.</label>
        </div>

        <div class="row m-3" *ngIf="changePasswordError">
            <label style="color: red">{{ changePasswordError }}</label>
        </div>

        <div class="row m-3">
            <button class="col btn btn-primary" [disabled]="!changePasswordForm.valid || changingPassword" type="submit">
                {{ changingPassword ? 'Saving...' : 'Set New Password' }}
            </button>
        </div>
        <div class="row m-3">
            <a href="javascript:void(0)" (click)="backToSignIn()">Back to Sign In</a>
        </div>
    </form>
</div>

<div *ngIf="signedIn">
  <h4>Sign In</h4>
  <div>
    You are already signed in!
  </div>
</div>

<div class="content-wrapper" *ngIf="!signedIn">
  <div class="footerLogo">
    <div class="company-logos">
      <div class="container">
        <div class="logos-wrapper d-flex justify-content-between align-items-center">
          <div class="axis-logo company-logo"></div>
          <div class="bellsupplycompany-logo company-logo"></div>
          <div class="caliber-logo company-logo"></div>
          <div class="commando-logo company-logo"></div>
          <div class="endurancelift-logo company-logo"></div>
          <div class="meritadvisors-logo company-logo"></div>
          <div class="sce-logo company-logo"></div>
        </div>
      </div>
    </div>
  </div>
</div>
